import BackIcon from '@assets/icons/back.svg?react'
import { MMButton } from '@components'
import SelectBank from '@components/SelectBank'
import { useBanksRequest } from 'mmfintech-checkout-commons'
import type { UseAdditionalFieldsOutput, UseFilteredBanksOutput } from 'mmfintech-checkout-commons/types'
import { tr, translatePaymentMethodName } from 'mmfintech-commons'
import { ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { shallowEqual, useSelector } from 'react-redux'

type SelectBankStepProps = {
  countryCode: string
  paymentMethod: string
  fieldValues: UseAdditionalFieldsOutput
  filteredBanks: UseFilteredBanksOutput
  onContinue: () => void
  onCancel?: () => void
  onBack?: () => void
  handleSearchFocus: () => void
  handleSearchType: () => void
}

const SelectBankStep = (props: SelectBankStepProps) => {
  const {
    countryCode,
    paymentMethod,
    fieldValues,
    filteredBanks,
    onContinue,
    onCancel,
    onBack,
    handleSearchFocus,
    handleSearchType
  } = props

  const { checkoutPayError, checkoutPayFetching, session, sessionError } = useSelector(
    ({ checkout: { checkoutPayError, checkoutPayFetching, session, sessionError } }) => ({
      checkoutPayError,
      checkoutPayFetching,
      session,
      sessionError
    }),
    shallowEqual
  )

  const { banksCount, banksLoaded } = useBanksRequest()

  return (
    <>
      {typeof onBack === 'function' && (
        <div className='back-button-wrapper'>
          <span onClick={onBack} data-test='back-button'>
            <BackIcon />
            <span>{tr('FRONTEND.BUTTONS.BACK', 'Back')}</span>
          </span>
        </div>
      )}

      <div className='payment-method-wrapper' data-test={`pay-with-${paymentMethod}-banks`}>
        {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay with {{METHOD}}', {
          METHOD: translatePaymentMethodName(paymentMethod)
        })}
      </div>

      {banksCount > 10 && (
        <div className='bank-search'>
          {/*<SearchIcon />*/}
          <Input
            key='bank-search'
            type='text'
            name='bank-search'
            data-test='bank-search-input'
            maxLength={50}
            value={filteredBanks.bankSearchText}
            onChange={(_name: string, value: string) => {
              filteredBanks.setBankSearchText(value)
              if (value?.length) {
                handleSearchType()
              }
            }}
            onFocus={handleSearchFocus}
            placeholder={
              countryCode === 'DEU'
                ? tr('CHECKOUT.PAYMENT.BANK_SEARCH_DEU', 'Search by bank name or BLZ')
                : tr('CHECKOUT.PAYMENT.BANK_SEARCH', 'Search by bank name')
            }
            hideErrorLine
            autoComplete='off'
          />
        </div>
      )}

      <SelectBank
        banksLoaded={banksLoaded}
        filteredBanks={filteredBanks}
        selectedBankId={fieldValues.getValue('bankChoiceId')}
        onContinue={onContinue}
        loading={checkoutPayFetching}
      />

      <ErrorDisplay error={[sessionError, checkoutPayError]} />

      <div className='buttons'>
        {/*<MMButton
          type='button'
          variant='primary'
          caption={tr('CHECKOUT.PAYMENT.BUTTON_PAY', 'Pay')}
          onClick={onContinue}
          loading={checkoutPayFetching}
          disabled={!fieldValues.getValue('bankChoiceId')}
          data-test='button-pay'
        />*/}

        {Boolean(session?.showCancelButton) && typeof onCancel === 'function' && (
          <MMButton
            type='button'
            variant='secondary'
            caption={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={onCancel}
            disabled={checkoutPayFetching}
            data-test='button-cancel'
          />
        )}
      </div>
    </>
  )
}

export default SelectBankStep
